export default __webpack_public_path__ + "static/media/music.310cbf54.mp3";